import { Alert } from 'avo-ui'
import { BrandNomination } from 'components/award/brand-nomination/BrandNomination'
import { INIT_STATE, INITIAL_DATA_FILTER } from 'configs/award/configTableBrandNomination'
import { ACTION_TYPE } from 'constants/constant'
import { useValidation } from 'hooks/useValidation'
import { useEffect, useState } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import { API_AWARD } from 'services/apiAward'
import { useFetch } from 'services/useFetch'
import { getAllQueryParams, getObjectName, setQueryParams, uploadFileToS3 } from 'utils/utils'

export const BrandNominationContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const [brandNominationDetail, setBrandNominationDetail] = useState(INIT_STATE)
    const [selectedIds, setSelectedIds] = useState([])
    const [isResetSelectedItem, setIsResetSelectedItem] = useState(false)
    const { fetching: getBrandList, data: dataBrandList, isLoading } = useFetch(API_AWARD.BRAND_LIST)
    const { fetching: createBrand, isLoading: isCreating } = useFetch(API_AWARD.BRAND_CREATE)
    const { fetching: updateBrand, isLoading: isUpdating } = useFetch(API_AWARD.BRAND_UPDATE)
    const { fetching: deleteBrand, isLoading: isDeleting } = useFetch(API_AWARD.BRAND_DELETE)
    const { fetching: getURLImage } = useFetch(API_AWARD.URL_AWARD_IMAGE)
    const { isFormValid } = useValidation({ form: brandNominationDetail })
    const [modal, setModal] = useState({
        delete: false,
        form: false,
    })

    useEffect(() => {
        fetchBrandList(query)
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const isReset = getObjectName(queryParams)?.some((item) => ['search'].includes(item))
        if (isReset) setIsResetSelectedItem(!isResetSelectedItem)
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const fetchBrandList = (item = { ...query }) => {
        getBrandList(item)
    }

    const setShowModal = (item) => {
        setModal({ ...modal, ...item })
    }

    const setShowAlert = (message, itemModal) => {
        setShowModal(itemModal)
        return Alert({
            icon: 'success',
            title: 'Success',
            message,
        })
    }

    const onHideForm = () => {
        setShowModal({ form: false })
    }

    const onSelectItemHandler = (item) => {
        const ids = item?.map((i) => i?.id)
        setSelectedIds(ids)
    }

    const onChangeForm = (e) => {
        const { name, value } = e
        setBrandNominationDetail({ ...brandNominationDetail, [name]: value })
    }

    const onActionRow = ({ item, actionType }) => {
        switch (actionType) {
            case ACTION_TYPE.CREATE:
                setBrandNominationDetail(INIT_STATE)
                setShowModal({ form: true })
                break
            case ACTION_TYPE.EDIT:
                setBrandNominationDetail(item)
                setShowModal({ form: true })
                break
            default:
                setBrandNominationDetail(item)
                setShowModal({ delete: true })
        }
    }

    const onDelete = async () => {
        await deleteBrand({ brand_ids: brandNominationDetail?.id ? [brandNominationDetail?.id] : selectedIds })
        setIsResetSelectedItem(!isResetSelectedItem)
        setShowAlert('Brand Nomination Deleted !', { delete: false })
        query?.page === '1' ? fetchBrandList(INITIAL_DATA_FILTER) : onChangeQuery(INITIAL_DATA_FILTER)
    }

    const handleUploadImage = async (file) => {
        const s3Urls = await getURLImage({ files: [file.name] })
        await uploadFileToS3(s3Urls?.data?.[0], file.file)
        return `${s3Urls?.data?.[0]?.url}${s3Urls?.data?.[0]?.fields?.key}`
    }

    const onSubmit = async () => {
        const isUpdate = !!brandNominationDetail.id
        const payload = {
            ...brandNominationDetail,
            image_url: brandNominationDetail?.image_url?.file
                ? await handleUploadImage(brandNominationDetail?.image_url)
                : brandNominationDetail?.image_url,
        }

        if (isUpdate) {
            await updateBrand(payload, brandNominationDetail.id)
            fetchBrandList(query)
        } else {
            await createBrand(payload)
            query?.page === '1' ? fetchBrandList(INITIAL_DATA_FILTER) : onChangeQuery(INITIAL_DATA_FILTER)
        }
        setShowAlert(`Brand Nomination ${isUpdate ? 'Updated' : 'Created'}!`, { form: false })
    }

    const props = {
        dataList: dataBrandList?.data,
        brandNominationDetail,
        modal,
        setShowModal,
        query,
        onChangeQuery,
        isFormValid,
        selectedIds,
        setSelectedIds,
        onSelectItemHandler,
        onActionRow,
        onChangeForm,
        onHideForm,
        onSubmit,
        onDelete,
        isLoading,
        isDeleting,
        isCreating,
        isUpdating,
        isResetSelectedItem,
    }

    return <BrandNomination {...props} />
}
